import MainLogo from "./logo.png";
import MainLogoDark from "./logo-dark-mode.png";
import BellIcon from "./Bell.svg";
import DimerecIcon from "./Dimerec_Icon.png";
import DimeXplainIcon from "./DimeXplain_Icon.png";
import CompanyConfig from "./Company_Config.png";
import SetupAndInvite from "./Setup_and_invite.png";
import Dashboard from "./dashboard.png";
import Notifications from "./Notifications-removebg-preview.png";
import TrustCenter from "./Trust_Center-removebg-preview.png";
import Support from "./Support.png";
import AIIcon from "./ai-icon.png";
import X from "./X.png";
import R from "./R.png";
import DimeAiIcon from "./DimeAI_Icon.png";
import LOGO_NEW from "./RepodimeWorkspaceLogo.png";
import LOGO_NEW_DARK from "./RepodimeWorkspaceLogoDark.png";
import MFA_SHIELD from "./login_carousel_1.png";
import ADAPTIVE_LOGIN_SHIELD from "./login_carousel_2.png";
import COMPLIANCE_SHIELD from "./login_carousel_3.png";
import DATA_RESIDENCY_SHIELD from "./login_carousel__4.png";

// Sidebar cyan icon set (recoloured per theme via CSS mask)
import DashboardCyan from "./dashboard-cyan.png";
import SetupInviteCyan from "./setup-invite-cyan-v2.svg";
import CompanyConfigCyan from "./company-config-cyan.png";
import PrivacyPolicyCyan from "./privacy-policy-cyan-v2.svg";
import ContactPrivacyCyan from "./contact-privacy-cyan-v2.svg";
import ManageDataCyan from "./manage-data-cyan.png";
import AiTransparencyCyan from "./ai-transparency-cyan.png";
import SubProcessorsCyan from "./sub-processors-cyan-v2.svg";
import NotificationsCyan from "./notifications-cyan.png";
import SupportCyan from "./support-cyan.png";
import DataUpload from "./upload-cyan-v2.svg";
import CONFIGURE_COA from "./manage-coa.png";
import AppsCyan from "./apps-cyan.svg";
import TrustCenterCyan from "./trust-center-cyan.svg";
// Manage Your Data / AI & Algorithm Transparency (Trust Center) get their
// own dedicated icon files -- MANAGE_DATA_CYAN and AI_TRANSPARENCY_CYAN
// above are shared with Audit Trail and Machine Learning (Admin Settings)
// respectively, and those must keep their existing icons untouched.
import TrustManageDataCyan from "./trust-manage-data-cyan.svg";
import TrustAiTransparencyCyan from "./trust-ai-transparency-cyan.svg";

// DimeAI sidebar siblings (Usage/Guardrails/Feedback/Reference Data/
// Tag-Independent Mode) — simple outline icons, recoloured amber via CSS
// mask (see .sidebar-icon-amber in style.css) so each reads distinctly from
// DimeAI's own green brain brand icon above (2026-10).
import DimeAiUsageAmber from "./dimeai-usage-amber.svg";
import DimeAiGuardrailsAmber from "./dimeai-guardrails-amber.svg";
import DimeAiFeedbackAmber from "./dimeai-feedback-amber.svg";
import DimeAiReferenceDataAmber from "./dimeai-reference-data-amber.svg";
import DimeAiTagIndependentAmber from "./dimeai-tag-independent-amber.svg";

export const images = {
  MAIN_LOGO: MainLogo,
  MAIN_LOGO_DARK: MainLogoDark,
  BELL_ICON: BellIcon,
  DIMEREC_ICON: DimerecIcon,
  DIMEXPLAIN_ICON: DimeXplainIcon,
  COMPANY_CONFIG: CompanyConfig,
  SETUP_AND_INVITE: SetupAndInvite,
  DASHBOARD: Dashboard,
  NOTIFICATIONS: Notifications,
  TRUST_CENTER: TrustCenter,
  SUPPORT: Support,
  AI_ICON: AIIcon,
  R: R,
  X: X,
  AI: DimeAiIcon,
  LOGO_NEW: LOGO_NEW,
  LOGO_NEW_DARK: LOGO_NEW_DARK,
  MFA_SHIELD: MFA_SHIELD,
  ADAPTIVE_LOGIN_SHIELD: ADAPTIVE_LOGIN_SHIELD,
  COMPLIANCE_SHIELD: COMPLIANCE_SHIELD,
  DATA_RESIDENCY_SHIELD: DATA_RESIDENCY_SHIELD,

  // Sidebar cyan icons
  DASHBOARD_CYAN: DashboardCyan,
  SETUP_INVITE_CYAN: SetupInviteCyan,
  COMPANY_CONFIG_CYAN: CompanyConfigCyan,
  PRIVACY_POLICY_CYAN: PrivacyPolicyCyan,
  CONTACT_PRIVACY_CYAN: ContactPrivacyCyan,
  MANAGE_DATA_CYAN: ManageDataCyan,
  AI_TRANSPARENCY_CYAN: AiTransparencyCyan,
  SUB_PROCESSORS_CYAN: SubProcessorsCyan,
  NOTIFICATIONS_CYAN: NotificationsCyan,
  SUPPORT_CYAN: SupportCyan,
  DATA_UPLOAD: DataUpload,
  CONFIGURE_COA: CONFIGURE_COA,
  APPS_CYAN: AppsCyan,
  TRUST_CENTER_CYAN: TrustCenterCyan,
  TRUST_MANAGE_DATA_CYAN: TrustManageDataCyan,
  TRUST_AI_TRANSPARENCY_CYAN: TrustAiTransparencyCyan,

  // DimeAI sidebar siblings — amber (see import comment above)
  DIMEAI_USAGE_AMBER: DimeAiUsageAmber,
  DIMEAI_GUARDRAILS_AMBER: DimeAiGuardrailsAmber,
  DIMEAI_FEEDBACK_AMBER: DimeAiFeedbackAmber,
  DIMEAI_REFERENCE_DATA_AMBER: DimeAiReferenceDataAmber,
  DIMEAI_TAG_INDEPENDENT_AMBER: DimeAiTagIndependentAmber,
};
